import { Locale } from "@msys/tolgee";
import React from "react";
import DEFlag from "./flags/de.svg?react";
import ENFlag from "./flags/en.svg?react";
import FRFlag from "./flags/fr.svg?react";
import NLFlag from "./flags/nl.svg?react";
import PLFlag from "./flags/pl.svg?react";
import RUFlag from "./flags/ru.svg?react";

export interface Language {
  locale: Locale;
  language_name: string;
  flag: React.ElementType;
  countryCode: string;
  countryName: string;
}

const enGB: Language = {
  locale: "en-GB",
  language_name: "English",
  flag: ENFlag,
  countryCode: "GBR",
  countryName: "Great Britain",
};
const de: Language = {
  locale: "de",
  language_name: "Deutsch",
  flag: DEFlag,
  countryCode: "DEU",
  countryName: "Germany",
};
const fr: Language = {
  locale: "fr",
  language_name: "Français",
  flag: FRFlag,
  countryCode: "FRA",
  countryName: "France",
};
const nl: Language = {
  locale: "nl",
  language_name: "Dutch",
  flag: NLFlag,
  countryCode: "NLD",
  countryName: "Netherlands",
};
const pl: Language = {
  locale: "pl",
  language_name: "Polski",
  flag: PLFlag,
  countryCode: "POL",
  countryName: "Poland",
};
const ru: Language = {
  locale: "ru",
  language_name: "Pyccкий",
  flag: RUFlag,
  countryCode: "RUS",
  countryName: "Russia",
};

export const languages: Record<string, Language> = {
  en: enGB,
  de,
  fr,
  nl,
  pl,
  ru,
};
